export default __webpack_public_path__ + "static/media/pwa.f77747a1.jpg";